/* eslint-disable complexity */
import { first_value } from '@/services/onboarding_form_helpers';

function get_selected_application_form_id(selected_form) {
  return Number(first_value([selected_form.application_form_id, selected_form.id], 0)) || null;
}

function resolve_entity_profile_id(entity_profile_id, selected_form, saved_application_form) {
  return Number(first_value([
    entity_profile_id,
    selected_form?.entity_profile_id,
    selected_form?.entity_profile,
    selected_form?.entity?.id,
    selected_form?.entity_profile?.id,
    saved_application_form?.entity_profile_id,
    saved_application_form?.entity_profile,
    saved_application_form?.entity?.id,
    saved_application_form?.entity_profile?.id
  ], 0)) || null;
}

function build_form_tree_payload(application_id, selected_application_form_id, resolved_entity_profile_id) {
  const payload = {
    application_id,
    application_form_id: selected_application_form_id
  };

  if (resolved_entity_profile_id) {
    payload.entity_profile_id = resolved_entity_profile_id;
  }

  return payload;
}

async function build_structure_only_response(selected_form, fetch_form_structure_fn, form_load_error) {
  return {
    data: await fetch_form_structure_fn(Number(selected_form.form_id)),
    allowed_actions: [],
    user_full_name: '',
    user_id: null,
    form_load_error
  };
}

function has_runtime_entity_profile(entity_profile_id, selected_form) {
  return Boolean(resolve_entity_profile_id(entity_profile_id, selected_form, null));
}

function build_workflow_form_request({
  application_id,
  selected_application_form_id,
  resolved_entity_profile_id,
  selected_form,
  fetch_form_tree_fn,
  fetch_form_structure_fn
}) {
  if (!selected_application_form_id && !resolved_entity_profile_id) {
    return build_structure_only_response(
      selected_form,
      fetch_form_structure_fn,
      'Unable to resolve entity profile for this application form; showing form structure only.'
    );
  }

  return fetch_form_tree_fn(
    build_form_tree_payload(application_id, selected_application_form_id, resolved_entity_profile_id)
  ).catch(function fallback_to_structure() {
    return build_structure_only_response(
      selected_form,
      fetch_form_structure_fn,
      'Unable to load saved form answers; showing form structure only.'
    );
  });
}

export async function load_selected_application_form_data({
  application_id,
  entity_profile_id,
  selected_form,
  fetch_form_tree_fn,
  fetch_form_structure_fn,
  fetch_application_form_fn
}) {
  const selected_application_form_id = get_selected_application_form_id(selected_form);
  const saved_application_form_request = selected_application_form_id
    ? fetch_application_form_fn(selected_application_form_id).catch(function no_saved_form() {
      return null;
    })
    : Promise.resolve(null);
  const can_parallel_load = has_runtime_entity_profile(entity_profile_id, selected_form);
  const saved_application_form = can_parallel_load ? null : await saved_application_form_request;
  const resolved_entity_profile_id = resolve_entity_profile_id(entity_profile_id, selected_form, saved_application_form);
  const workflow_form_request = build_workflow_form_request({
    application_id,
    selected_application_form_id,
    resolved_entity_profile_id,
    selected_form,
    fetch_form_tree_fn,
    fetch_form_structure_fn
  });
  const responses = await Promise.all([workflow_form_request, saved_application_form_request]);
  return [responses[0], responses[1]];
}
